import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { getLanguage } from "../../../utils/environment";
import { getCategoryById } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getNewsByCategoryPage } from "../../news/service/news.service";
import { NewsCard, NewsGroup } from "../../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

const categoryId = process.env.REACT_APP_HOT_NEWS || "67d841d3ec995c0cecc999c2";
const pageCount = "2";
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");

  useEffect(() => {
    async function fetchPageData() {
      try {
        let res = await getCategoryById(categoryId);
        console.log(res);
        if (res?.data) {
          setMenu(res?.data);
          let response = await getNewsByCategoryPage(
            categoryId,
            pageCount,
            lan
          );
          console.log("response getNewsByCategoryPage::", response);
          if (response?.data) {
            setNews(response?.data?.news);
          } else {
            setNews([]);
          }
        } else {
          setNews([]);
        }

        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
    setIsLoading(true);
    fetchPageData();
  }, []);

  return (
    <>
      <NewsGroup
        data={{
          titleName: menu?.name?.[lan] || "",
          linkName:
            lan === "en"
              ? "More " + menu?.name?.[lan]
              : "තවත් " + menu?.name?.[lan],
        }}
        onClickViewNews={() => {
          props.history.push("/" + categoryId);
          props.setMenuName(categoryId);
        }}
      >
        <div className="news-row">
          {isLoading && <NewsCard data={{ type: "loading", isBorder: true }} />}
          {!isLoading &&
            news
              .filter(
                (item) => item.title?.[lan] && item.title[lan].trim() !== ""
              )
              .map((item, index) => (
                <NewsCard
                  data={{ type: "small", isBorder: true }}
                  item={item}
                  onClick={() => {
                    const generatedSlug = item?.title?.[lan]
                      ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                      ?.replace(/\//g, "")
                      ?.replace(/\s*-\s*/g, " ")
                      ?.trim()
                      .split(/\s+/)
                      .slice(0, 5)
                      .join("-")
                      .replace(/-+/g, "-");
                    props.history.push(`/${generatedSlug}/${item?.news_id}`);
                  }}
                />
              ))}
        </div>
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
